import { SliderField } from './SliderField';
import { useEditor, useNode } from '@craftjs/core';
import { editorRegistry } from '@/components/userComponents/Text';
import { Editor as SlateEditor } from 'slate';
import { applyMark } from '@/utils/textUtils';
import { isTextBlockNode } from '@/utils/helperFunc';

const NodeSpaceSettings = () => {
  const { id, props, node } = useNode((node) => ({
    node: node,
    id: node.id,
    props: node.data.props,
  }));
  const { actions } = useEditor();

  const getLetterSpacing = () => {
    const slateEditor = editorRegistry.get(id);
    if (!slateEditor) return;
    const { editor } = slateEditor;
    const marks = SlateEditor.marks(editor);
    const value =
      marks != undefined && Object.keys(marks)?.length > 0 && marks['letterSpacing'] != undefined
        ? marks['letterSpacing']
        : 0;
    return value;
  };

  const updateSpacing = (value: number, skipHistory = false) => {
    const actionMethod = skipHistory ? actions.history.ignore().setProp : actions.setProp;
    actionMethod(id, (props: Partial<{ letterSpacing: number }>) => {
      props.letterSpacing = value;
    });
  };

  const updateSlateSpacing = (value: number) => {
    const slateEditor = editorRegistry.get(id);
    if (!slateEditor) return;
    const { editor } = slateEditor;
    applyMark(editor, 'letterSpacing', value);
  };

  const handleOnChangeSpacing = (e: number) => {
    if (isTextBlockNode(node)) {
      updateSlateSpacing(e);
    } else {
      updateSpacing(e, true);
    }
  };

  const handleOnChangeSpacingComplete = (value: number, initialValue: number) => {
    if (isTextBlockNode(node)) {
      updateSlateSpacing(value);
    } else {
      updateSpacing(initialValue, true);
      updateSpacing(value);
    }
  };

  return (
    <SliderField
      label="Spacing"
      value={isTextBlockNode(node) ? getLetterSpacing() : props.letterSpacing || 0}
      onChange={handleOnChangeSpacing}
      onChangeComplete={handleOnChangeSpacingComplete}
      min={-2}
      max={2}
      step={0.01}
      allowDecimal={true}
    />
  );
};

export default NodeSpaceSettings;
